import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import 'primeflex/primeflex.css';

const Home = () => {
  const navigate = useNavigate();

  const pagesUsers = [
    {
      title: "Empleados",
      description: "Visualiza y administra los empleados de la nómina seleccionada.",
      path: "/empleados/listado",
      label: "Ver empleados",
      icon: "pi pi-users",
      color: "bg-blue-100 text-blue-800"
    },
    {
      title: "Faltas",
      description: "Registre las faltas sin goce de sueldo para el periodo actual.",
      path: "/faltas",
      label: "Registrar falta",
      icon: "pi pi-calendar-times",
      color: "bg-red-100 text-red-800"
    },
    {
      title: "Captura de bonos",
      description: "Registre los bonos a los empleados para el periodo actual.",
      path: "/bonos",
      label: "Capturar bonos",
      icon: "pi pi-gift",
      color: "bg-green-100 text-green-800"
    },
    {
      title: "Cambios de salario",
      description: "Capture solicitudes de cambio de salario por empleado.",
      path: "/cambio-salario",
      label: "Registrar solicitud",
      icon: "pi pi-wallet",
      color: "bg-yellow-100 text-yellow-800"
    },
    {
      title: "Solicitudes de bajas",
      description: "Capture las bajas de empleados.",
      path: "/baja-empleados",
      label: "Registrar baja",
      icon: "pi pi-user-minus",
      color: "bg-purple-100 text-purple-800"
    },
    
  ];

  return (
    <div className="p-4">
      <h1 className="mb-4 text-2xl font-bold">Inicio</h1>

      <div className="grid">
        {pagesUsers.map((page, idx) => (
          <div key={idx} className="col-12 md:col-4">
            <Card className="h-full shadow-2 border-round p-3">
              <div className={`flex items-center gap-2 text-lg font-bold mb-2 p-2 border-round ${page.color}`}>
                <i className={page.icon}></i>
                {page.title}
              </div>
              <p className="text-gray-700 mb-3">{page.description}</p>
              <Button
                label={page.label}
                className="bg-cyan-500 hover:bg-cyan-600 border-none"
                icon="pi pi-arrow-right"
                onClick={() => navigate(page.path)}
              />
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Home;
